module.exports = __webpack_public_path__ + "static/media/icon_in_red_circle.e67b6564.svg";